import ConnectServer from 'utils/connect_server'
import * as types from 'redux/types'
import { message, notification } from 'antd';


export const onChangeAuth = (prop, value): any => (dispatch) => {
  dispatch({ type: types.CHANGE_AUTH, payload: { prop, value } });
}
export const onChangeTime = (): any => (dispatch) => {
  dispatch({ type: types.CHANGE_TIMER, payload: { } });
}

export const login = (form): any => (dispatch) => {

  onChangeAuth('loginLoading',true)(dispatch)
  return ConnectServer(`basic-authentication/send-verify-code?phone=${form.getFieldsValue().username}`, "POST", 'application/json', null,).then((res: any) => {
  // return ConnectServer(`basic-authentication/index?captcha=123123`, "POST", 'application/json', null,{basicType:1,username:"super_admin",password:form.getFieldsValue().password}).then((res: any) => {
    // dispatch({ type: types.AUTH_SET_INFO, payload: res });
    return res
  }).finally(() => { 
    onChangeAuth('loginLoading',false)(dispatch)  
  })
}

export const signUp = (formData): any => (dispatch) => {
  onChangeAuth('signUpLoading',true)(dispatch)
  return ConnectServer(`basic-authentication/register`, "POST", null, formData).then((res: any) => {
    return res
  }).catch((res: any) => {
    console.log(res?.errors[0]?.username);
    
    if(res?.errors?.username[0])
    notification.warning({
      message: "",
      description: res?.errors?.username[0],
      placement: 'bottomLeft',
  });
  })
  .finally(() => { 
    onChangeAuth('signUpLoading',false)(dispatch)  
  })
}
export const checkVerify = (phone,code): any => (dispatch) => {

  onChangeAuth('verifyLoading',true)(dispatch)
  return ConnectServer(`basic-authentication/check-verify-code?phone=${phone}&verifyCode=${code}&captcha=123123`, "POST", null, null).then((res: any) => {
    return res
  }).finally(() => { 
    onChangeAuth('verifyLoading',false)(dispatch)  
  })
}
export const resendCodeAction = (phone): any => (dispatch) => {

  onChangeAuth('resendCodeLoading',true)(dispatch)
  return ConnectServer(`basic-authentication/send-verify-code?phone=${phone}`, "POST", 'application/json', null).then((res: any) => {
    return res
  }).finally(() => { 
    onChangeAuth('resendCodeLoading',false)(dispatch)  
  })
}
export const forgetPasswordAction = (phone): any => (dispatch) => {

  onChangeAuth('forgetPasswordLoading',true)(dispatch)
  return ConnectServer(`basic-authentication/forget-password?phone=${phone}`, "POST", 'application/json', null).then((res: any) => {
    return res
  }).finally(() => { 
    onChangeAuth('forgetPasswordLoading',false)(dispatch)  
  })
}
export const ChangePasswordAction = (query): any => (dispatch) => {

  onChangeAuth('changePasswordLoading',true)(dispatch)
  return ConnectServer(`basic-authentication/confirm-password?${query}`, "POST", 'application/json', null).then((res: any) => {
    return res
  }).finally(() => { 
    onChangeAuth('changePasswordLoading',false)(dispatch)  
  })
}

// export const getPermissionUser = (): any => (dispatch) => {
//   onChangeAuth('loginLoading',true)(dispatch)  
//  return ConnectServer('basic-authentication/all-permissions-by-users', "GET", 'application/json', null).then((res: any) => {
//   dispatch({ type: types.CHANGE_AUTH_SET_PERMISSION, payload:res }); 
//   return res 
//   }).catch(() => {
//     onChangeAuth('loginLoading',false)(dispatch)  
//   })
// }

